import React from 'react';
import { Card } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const ConservationsChartCard = ({
  labels,
  conversationStatsData,
  conversationNightStatsData,
}) => {
  const conversationDatasets = conversationStatsData.map(elem => elem.count);
  const conversationNightDatasets = conversationNightStatsData.map(
    elem => elem.count
  );
  const areaChartData = {
    labels,
    datasets: [
      {
        label: 'conversations',
        data: conversationDatasets,
        borderColor: colors.themeColor1,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor1,
        pointHoverBackgroundColor: colors.themeColor1,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: false,
        borderWidth: 2,
        backgroundColor: colors.themeColor1_10,
      },
      {
        label: 'night',
        data: conversationNightDatasets,
        borderColor: colors.themeColor2,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor2,
        pointHoverBackgroundColor: colors.themeColor2,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: true,
        borderWidth: 2,
        backgroundColor: colors.themeColor2_10,
      },
    ],
  };
  return (
    <Card className="dashboard-filled-line-chart">
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              <IntlMessages id="dashboards.digital-assistant-engagement" />
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.total-overnight-conversations" />
            </span>
          </div>
        </div>
      </div>

      <div className="chart card-body pt-0">
        <AreaChart shadow data={areaChartData} />
      </div>
    </Card>
  );
};

export default ConservationsChartCard;
